export const lexideskButtons = () => {
	const buttons = document.querySelectorAll('a[href*="chat-with-us"]');
	if(!buttons || buttons.length === 0) {
		return;
	}
	buttons.forEach( ( button ) => {
		button.addEventListener( 'click', (e) => {
			e.preventDefault();
			lexideskOpenChat();
		} );
	} );
};

export const lexideskWpmlFix = () => {
	const wpmlUl = document.querySelector('.wpml-ls > ul');
    if (wpmlUl) {
        wpmlUl.addEventListener('mouseenter', () => {
            lexideskHideBubble();
        });
        wpmlUl.addEventListener('mouseleave', () => {
            lexideskShowBubble();
        });
    }
}

const lexideskOpenChat = () => {
	if(window.lexidesk === undefined) {
		console.warn('LexiDesk widget is not loaded');
		return;
	}
	window.lexidesk.fireEvent('START_OR_CONTINUE_LEXIDESK_WIDGET_CONVERSATION');
}

const lexideskHideBubble = () => {
	if(window.lexidesk === undefined) {
		console.warn('LexiDesk widget is not loaded');
		return;
	}
	window.lexidesk.fireEvent('HIDE_LEXIDESK_WIDGET');
}

const lexideskShowBubble = () => {
	if(window.lexidesk === undefined) {
		console.warn('LexiDesk widget is not loaded');
		return;
	}
	window.lexidesk.fireEvent('SHOW_LEXIDESK_WIDGET');
}
